import React, { useEffect, useState } from "react";
import { Modal, Box } from "@mui/material";
import { useForm } from "react-hook-form";



import { acceptNursesHandoverSummary, getHandoverEmp,
  getNureseHandoverFullData,
  getNursingHandoverEmp,
  saveNursesHandover, } from "./NursesHandoverServices";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import CommonDivider from "../../../../common/components/divider/CommonDivider";
import InputField from "../../../../common/components/FormFields/InputField";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import ISBARCheckbox from "./ISBARCheckbox";
import { errorAlert, successAlert } from "../../../../common/components/Toasts/CustomToasts";
import { ModalStyle } from "../../../../common/components/ModalStyle";
import { ViewIconISBAR } from "../../../../assets/CommonAssets";
import { UseCheckConsecutiveCharacters } from "../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import NursesHandoverPasscodeModal from "./NursesHandoverPasscodeModal";
import NursesHandoverListingModal from "./NursesHandoverListingModal";


const NursesHandoverBasedOnISBARModal = ({
  openIsbarNurseHandoverModal,
  setOpenIsbarNurseHandoverModal,
  displayInfo
  //  = {
  //   AdmissionId: 1092122,
  //   "Patient Name": "Sameer Patil",
  //   MRNo: "MR2026001",
  //   AgeYear: 45,
  //   DoctorName: "Dr.Smith",
  //   "Bed No": "B-12",
  // },
}) => {
  const defaultValues = {
    assignStaff: null,
    assignStaffEvening: null,
    assignStaffNight: null,

    // PATIENT ASSESSMENT

    "Patient Identification_M_Yes": false,
    "Patient Identification_M_No": false,
    "Patient Identification_M_Remark": "",

    "Patient Identification_E_Yes": false,
    "Patient Identification_E_No": false,
    "Patient Identification_E_Remark": "",

    "Patient Identification_N_Yes": false,
    "Patient Identification_N_No": false,
    "Patient Identification_N_Remark": "",

    "Current Problems_M_Yes": false,
    "Current Problems_M_No": false,
    "Current Problems_M_Remark": "",

    "Current Problems_E_Yes": false,
    "Current Problems_E_No": false,
    "Current Problems_E_Remark": "",

    "Current Problems_N_Yes": false,
    "Current Problems_N_No": false,
    "Current Problems_N_Remark": "",

    "Treatment Updates_M_Yes": false,
    "Treatment Updates_M_No": false,
    "Treatment Updates_M_Remark": "",

    "Treatment Updates_E_Yes": false,
    "Treatment Updates_E_No": false,
    "Treatment Updates_E_Remark": "",

    "Treatment Updates_N_Yes": false,
    "Treatment Updates_N_No": false,
    "Treatment Updates_N_Remark": "",

    "Bedsore Stages / Skin Condition_M_Yes": false,
    "Bedsore Stages / Skin Condition_M_No": false,
    "Bedsore Stages / Skin Condition_M_Remark": "",

    "Bedsore Stages / Skin Condition_E_Yes": false,
    "Bedsore Stages / Skin Condition_E_No": false,
    "Bedsore Stages / Skin Condition_E_Remark": "",

    "Bedsore Stages / Skin Condition_N_Yes": false,
    "Bedsore Stages / Skin Condition_N_No": false,
    "Bedsore Stages / Skin Condition_N_Remark": "",

    "IV Cannula Patent_M_Yes": false,
    "IV Cannula Patent_M_No": false,
    "IV Cannula Patent_M_Remark": "",

    "IV Cannula Patent_E_Yes": false,
    "IV Cannula Patent_E_No": false,
    "IV Cannula Patent_E_Remark": "",

    "IV Cannula Patent_N_Yes": false,
    "IV Cannula Patent_N_No": false,
    "IV Cannula Patent_N_Remark": "",

    "CVL/HD Cath/Foleys Cath/AV Fistula_M_Yes": false,
    "CVL/HD Cath/Foleys Cath/AV Fistula_M_No": false,
    "CVL/HD Cath/Foleys Cath/AV Fistula_M_Remark": "",

    "CVL/HD Cath/Foleys Cath/AV Fistula_E_Yes": false,
    "CVL/HD Cath/Foleys Cath/AV Fistula_E_No": false,
    "CVL/HD Cath/Foleys Cath/AV Fistula_E_Remark": "",

    "CVL/HD Cath/Foleys Cath/AV Fistula_N_Yes": false,
    "CVL/HD Cath/Foleys Cath/AV Fistula_N_No": false,
    "CVL/HD Cath/Foleys Cath/AV Fistula_N_Remark": "",

    "O2 Therapy / Room Air_M_Yes": false,
    "O2 Therapy / Room Air_M_No": false,
    "O2 Therapy / Room Air_M_Remark": "",

    "O2 Therapy / Room Air_E_Yes": false,
    "O2 Therapy / Room Air_E_No": false,
    "O2 Therapy / Room Air_E_Remark": "",

    "O2 Therapy / Room Air_N_Yes": false,
    "O2 Therapy / Room Air_N_No": false,
    "O2 Therapy / Room Air_N_Remark": "",

    Diet_M_Yes: false,
    Diet_M_No: false,
    Diet_M_Remark: "",

    Diet_E_Yes: false,
    Diet_E_No: false,
    Diet_E_Remark: "",

    Diet_N_Yes: false,
    Diet_N_No: false,
    Diet_N_Remark: "",

    "IV Fluid / Infusion_M_Yes": false,
    "IV Fluid / Infusion_M_No": false,
    "IV Fluid / Infusion_M_Remark": "",

    "IV Fluid / Infusion_E_Yes": false,
    "IV Fluid / Infusion_E_No": false,
    "IV Fluid / Infusion_E_Remark": "",

    "IV Fluid / Infusion_N_Yes": false,
    "IV Fluid / Infusion_N_No": false,
    "IV Fluid / Infusion_N_Remark": "",

    "Urine Output_M_Yes": false,
    "Urine Output_M_No": false,
    "Urine Output_M_Remark": "",

    "Urine Output_E_Yes": false,
    "Urine Output_E_No": false,
    "Urine Output_E_Remark": "",

    "Urine Output_N_Yes": false,
    "Urine Output_N_No": false,
    "Urine Output_N_Remark": "",

    "Bowel Movement / Colostomy_M_Yes": false,
    "Bowel Movement / Colostomy_M_No": false,
    "Bowel Movement / Colostomy_M_Remark": "",

    "Bowel Movement / Colostomy_E_Yes": false,
    "Bowel Movement / Colostomy_E_No": false,
    "Bowel Movement / Colostomy_E_Remark": "",

    "Bowel Movement / Colostomy_N_Yes": false,
    "Bowel Movement / Colostomy_N_No": false,
    "Bowel Movement / Colostomy_N_Remark": "",

    // MEDICATIONS

    Allergies_M_Yes: false,
    Allergies_M_No: false,
    Allergies_M_Remark: "",

    Allergies_E_Yes: false,
    Allergies_E_No: false,
    Allergies_E_Remark: "",

    Allergies_N_Yes: false,
    Allergies_N_No: false,
    Allergies_N_Remark: "",

    "High Risk Medication_M_Yes": false,
    "High Risk Medication_M_No": false,
    "High Risk Medication_M_Remark": "",

    "High Risk Medication_E_Yes": false,
    "High Risk Medication_E_No": false,
    "High Risk Medication_E_Remark": "",

    "High Risk Medication_N_Yes": false,
    "High Risk Medication_N_No": false,
    "High Risk Medication_N_Remark": "",

    "Medicines In Fridge_M_Yes": false,
    "Medicines In Fridge_M_No": false,
    "Medicines In Fridge_M_Remark": "",

    "Medicines In Fridge_E_Yes": false,
    "Medicines In Fridge_E_No": false,
    "Medicines In Fridge_E_Remark": "",

    "Medicines In Fridge_N_Yes": false,
    "Medicines In Fridge_N_No": false,
    "Medicines In Fridge_N_Remark": "",

    "Pending Indent / Medication Administration_M_Yes": false,
    "Pending Indent / Medication Administration_M_No": false,
    "Pending Indent / Medication Administration_M_Remark": "",

    "Pending Indent / Medication Administration_E_Yes": false,
    "Pending Indent / Medication Administration_E_No": false,
    "Pending Indent / Medication Administration_E_Remark": "",

    "Pending Indent / Medication Administration_N_Yes": false,
    "Pending Indent / Medication Administration_N_No": false,
    "Pending Indent / Medication Administration_N_Remark": "",

    // HYGIENIC NEEDS

    "Patient Dress Changes / Bath / Foleys_M_Yes": false,
    "Patient Dress Changes / Bath / Foleys_M_No": false,
    "Patient Dress Changes / Bath / Foleys_M_Remark": "",

    "Patient Dress Changes / Bath / Foleys_E_Yes": false,
    "Patient Dress Changes / Bath / Foleys_E_No": false,
    "Patient Dress Changes / Bath / Foleys_E_Remark": "",

    "Patient Dress Changes / Bath / Foleys_N_Yes": false,
    "Patient Dress Changes / Bath / Foleys_N_No": false,
    "Patient Dress Changes / Bath / Foleys_N_Remark": "",

    "Catheter / Oral / Back Care Given_M_Yes": false,
    "Catheter / Oral / Back Care Given_M_No": false,
    "Catheter / Oral / Back Care Given_M_Remark": "",

    "Catheter / Oral / Back Care Given_E_Yes": false,
    "Catheter / Oral / Back Care Given_E_No": false,
    "Catheter / Oral / Back Care Given_E_Remark": "",

    "Catheter / Oral / Back Care Given_N_Yes": false,
    "Catheter / Oral / Back Care Given_N_No": false,
    "Catheter / Oral / Back Care Given_N_Remark": "",

    // Additional Fields

    "Procedure / Surgery Plan For The Day_M_Remark": "",
    "Procedure / Surgery Plan For The Day_E_Remark": "",
    "Procedure / Surgery Plan For The Day_N_Remark": "",

    "Blood Products Demand_M_Remark": "",
    "Blood Products Demand_E_Remark": "",
    "Blood Products Demand_N_Remark": "",

    "Any Investigation Sent_M_Remark": "",
    "Any Investigation Sent_E_Remark": "",
    "Any Investigation Sent_N_Remark": "",

    "Any Pending Reports / Investigations_M_Remark": "",
    "Any Pending Reports / Investigations_E_Remark": "",
    "Any Pending Reports / Investigations_N_Remark": "",

    "Special Instructions / Recommendations_M_Remark": "",
    "Special Instructions / Recommendations_E_Remark": "",
    "Special Instructions / Recommendations_N_Remark": "",
  };

  const handoverSections = [
    {
      section: "PATIENT ASSESSMENT",
      fields: [
        // "IPD File",
        "Patient Identification",
        "Current Problems",
        "Treatment Updates",
        "Bedsore Stages / Skin Condition",
        "IV Cannula Patent",
        "CVL/HD Cath/Foleys Cath/AV Fistula",
        "O2 Therapy / Room Air",
        "Diet",
        "IV Fluid / Infusion",
        "Urine Output",
        "Bowel Movement / Colostomy",
      ],
    },

    {
      section: "MEDICATIONS",
      fields: [
        "Allergies",
        "High Risk Medication",
        "Medicines In Fridge",
        // "Costly Medications",
        "Pending Indent / Medication Administration",
      ],
    },

    {
      section: "HYGIENIC NEEDS",
      fields: [
        "Patient Dress Changes / Bath / Foleys",
        "Catheter / Oral / Back Care Given",
      ],
    },
  ];
  const additionalHandoverFields = [
    {
      id: 1,
      text: "Procedure / Surgery Plan For The Day",
    },
    {
      id: 2,
      text: "Blood Products Demand",
    },
    {
      id: 3,
      text: "Any Investigation Sent",
    },
    {
      id: 4,
      text: "Any Pending Reports / Investigations",
    },
    {
      id: 5,
      text: "Special Instructions / Recommendations",
    },
  ];
  const getUserInfo = JSON.parse(localStorage.getItem("userInfo"));
  // const admissionId = 2;
  const [openPostModal, setOpenPostModal] = useState(false);
  const [handoverResultArray, setHandoverResultArray] = useState([]);
  const [empData, setEmpData] = useState([]);

  const [finalData, setFinalData] = useState({});
  const [selectedShift, setSelectedShift] = useState("M");
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const { control, handleSubmit, setValue, reset } = useForm({ defaultValues });
  const [employeeNameOptions, setEmployeeNameOptions] = useState([]);
  const [nursesHandoverListingModal, setNursesHandoverListingModal] =
    useState(false);
  const [passcodeModal, setPasscodeModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [pendingAcceptShift, setPendingAcceptShift] = useState(null);

  const morningData = handoverResultArray?.find((item) => item?.shift === "M");

  const eveningData = handoverResultArray?.find((item) => item?.shift === "E");

  const nightData = handoverResultArray?.find((item) => item?.shift === "N");
  const allFields = handoverSections?.flatMap((section) => section.fields);
  const fetchNursesHandoverData = async () => {
    if (!displayInfo?.AdmissionId) return;
    setHandoverResultArray([]);
    reset({ ...defaultValues });
    try {
      setOpenBackdrop(true);
      let Obj = {
        admissionId: selectedRow?.admissionId ?? displayInfo?.AdmissionId,
        dateTime: selectedRow?.EntryDate ?? null,
      };
      const response = await getNureseHandoverFullData(Obj);

      const res = response?.data;

      if (res?.statusCode === 200) {
        const resultArray = res?.result || [];

        setHandoverResultArray(resultArray);

        const fieldMap = {
          "Patient Identification": "patientIdentification",
          "Current Problems": "currentProblems",
          "Treatment Updates": "treatmentUpdates",
          "Bedsore Stages / Skin Condition": "bedsoreStages",
          "IV Cannula Patent": "ivCannulaPatent",
          "CVL/HD Cath/Foleys Cath/AV Fistula": "patientLine",
          "O2 Therapy / Room Air": "o2Therapy",
          Diet: "diet",
          "IV Fluid / Infusion": "infusion",
          "Urine Output": "urineOutput",
          "Bowel Movement / Colostomy": "bowelMovement",
          Allergies: "allergies",
          "High Risk Medication": "highRiskMedication",
          "Medicines In Fridge": "medicinesInFridge",
          "Pending Indent / Medication Administration": "pendingIndent",
          "Patient Dress Changes / Bath / Foleys": "patientDressChanges",
          "Catheter / Oral / Back Care Given": "catheterCare",
        };

        resultArray.forEach((result) => {
          const shift = result?.shift;

          if (!shift) return;

          Object.entries(fieldMap).forEach(([fieldLabel, apiField]) => {
            const value = result?.[apiField];

            setValue(`${fieldLabel}_${shift}_Yes`, value === true);
            setValue(`${fieldLabel}_${shift}_No`, value === false);

            setValue(
              `${fieldLabel}_${shift}_Remark`,
              result?.[`${apiField}Remark`] || "",
            );
          });

          setValue(
            `Procedure / Surgery Plan For The Day_${shift}_Remark`,
            result?.procedurePlanRemark || "",
          );

          setValue(
            `Blood Products Demand_${shift}_Remark`,
            result?.bloodProductsDemandRemark || "",
          );

          setValue(
            `Any Investigation Sent_${shift}_Remark`,
            result?.anyInvestigationSentRemark || "",
          );

          setValue(
            `Any Pending Reports / Investigations_${shift}_Remark`,
            result?.anyPendingReportsRemark || "",
          );

          setValue(
            `Special Instructions / Recommendations_${shift}_Remark`,
            result?.specialInstructionRemark || "",
          );
        });
      }
    } catch (error) {
      console.error("Failed to fetch nurses handover:", error);
    } finally {
      setOpenBackdrop(false);
    }
  };
  const onSubmit = (data) => {
    const shift = selectedShift;

    const missingFields = allFields.filter((field) => {
      const yes = data[`${field}_${shift}_Yes`];
      const no = data[`${field}_${shift}_No`];

      return !yes && !no;
    });

    if (missingFields.length > 0) {
      console.log(missingFields, "missingFields");
      errorAlert(`Please select Yes or No for all fields before saving.`);
      return;
    }
    const handOverToMap = {
      M: data?.assignStaff,
      E: data?.assignStaffEvening,
      N: data?.assignStaffNight,
    };

    // const selectedEmployee = handOverToMap[shift];
    const selectedEmployee = handOverToMap[shift] || {
      id: handoverResultArray?.find((item) => item?.shift === shift)
        ?.handOverToId,
    };
    if (!selectedEmployee?.id) {
      errorAlert("Please Select Hondover To Name");
      return;
    }
    const payload = {
      // ipdFile: data[`IPD File_${shift}_Yes`] || false,
      // ipdFileRemark: data[`IPD File_${shift}_Remark`] || "",
      id:
        handoverResultArray?.find((item) => item?.shift === shift)?.id || null,
      patientIdentification:
        data[`Patient Identification_${shift}_Yes`] || false,
      patientIdentificationRemark:
        data[`Patient Identification_${shift}_Remark`] || "",

      currentProblems: data[`Current Problems_${shift}_Yes`] || false,
      currentProblemsRemark: data[`Current Problems_${shift}_Remark`] || "",

      treatmentUpdates: data[`Treatment Updates_${shift}_Yes`] || false,
      treatmentUpdatesRemark: data[`Treatment Updates_${shift}_Remark`] || "",

      bedsoreStages:
        data[`Bedsore Stages / Skin Condition_${shift}_Yes`] || false,
      bedsoreStagesRemark:
        data[`Bedsore Stages / Skin Condition_${shift}_Remark`] || "",

      ivCannulaPatent: data[`IV Cannula Patent_${shift}_Yes`] || false,
      ivCannulaPatentRemark: data[`IV Cannula Patent_${shift}_Remark`] || "",

      patientLine:
        data[`CVL/HD Cath/Foleys Cath/AV Fistula_${shift}_Yes`] || false,
      patientLineRemark:
        data[`CVL/HD Cath/Foleys Cath/AV Fistula_${shift}_Remark`] || "",

      o2Therapy: data[`O2 Therapy / Room Air_${shift}_Yes`] || false,
      o2TherapyRemark: data[`O2 Therapy / Room Air_${shift}_Remark`] || "",

      diet: data[`Diet_${shift}_Yes`] || false,
      dietRemark: data[`Diet_${shift}_Remark`] || "",

      infusion: data[`IV Fluid / Infusion_${shift}_Yes`] || false,
      infusionRemark: data[`IV Fluid / Infusion_${shift}_Remark`] || "",

      urineOutput: data[`Urine Output_${shift}_Yes`] || false,
      urineOutputRemark: data[`Urine Output_${shift}_Remark`] || "",

      bowelMovement: data[`Bowel Movement / Colostomy_${shift}_Yes`] || false,
      bowelMovementRemark:
        data[`Bowel Movement / Colostomy_${shift}_Remark`] || "",

      allergies: data[`Allergies_${shift}_Yes`] || false,
      allergiesRemark: data[`Allergies_${shift}_Remark`] || "",

      highRiskMedication: data[`High Risk Medication_${shift}_Yes`] || false,
      highRiskMedicationRemark:
        data[`High Risk Medication_${shift}_Remark`] || "",

      medicinesInFridge: data[`Medicines In Fridge_${shift}_Yes`] || false,
      medicinesInFridgeRemark:
        data[`Medicines In Fridge_${shift}_Remark`] || "",

      // costlyMedications: data[`Costly Medications_${shift}_Yes`] || false,
      // costlyMedicationsRemark: data[`Costly Medications_${shift}_Remark`] || "",

      pendingIndent:
        data[`Pending Indent / Medication Administration_${shift}_Yes`] ||
        false,
      pendingIndentRemark:
        data[`Pending Indent / Medication Administration_${shift}_Remark`] ||
        "",

      patientDressChanges:
        data[`Patient Dress Changes / Bath / Foleys_${shift}_Yes`] || false,
      patientDressChangesRemark:
        data[`Patient Dress Changes / Bath / Foleys_${shift}_Remark`] || "",

      procedurePlan: data[
        `Procedure / Surgery Plan For The Day_${shift}_Remark`
      ]
        ? true
        : false,
      procedurePlanRemark:
        data[`Procedure / Surgery Plan For The Day_${shift}_Remark`] || "",

      bloodProductsDemand: data[`Blood Products Demand_${shift}_Remark`]
        ? true
        : false,
      bloodProductsDemandRemark:
        data[`Blood Products Demand_${shift}_Remark`] || "",

      anyInvestigationSent: data[`Any Investigation Sent_${shift}_Remark`]
        ? true
        : false,
      anyInvestigationSentRemark:
        data[`Any Investigation Sent_${shift}_Remark`] || "",

      anyPendingReports: data[
        `Any Pending Reports / Investigations_${shift}_Remark`
      ]
        ? true
        : false,
      anyPendingReportsRemark:
        data[`Any Pending Reports / Investigations_${shift}_Remark`] || "",

      specialInstruction: data[
        `Special Instructions / Recommendations_${shift}_Remark`
      ]
        ? true
        : false,
      specialInstructionRemark:
        data[`Special Instructions / Recommendations_${shift}_Remark`] || "",
      catheterCare:
        data[`Catheter / Oral / Back Care Given_${shift}_Yes`] || false,

      catheterCareRemark:
        data[`Catheter / Oral / Back Care Given_${shift}_Remark`] || "",
      shift,
      admissionId: displayInfo?.AdmissionId,
      handOverBy: getUserInfo?.userId,
      handOverTo: selectedEmployee?.id || null,
    };

    setFinalData(payload);
    setOpenPostModal(true);
  };

  const handleSaveRecord = () => {
    setOpenBackdrop(true);

    saveNursesHandover(finalData)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 409) {
          errorAlert("This record already exists.");
        } else if (res.statusCode === 200 || res.statusCode === 201) {
          successAlert(res.message);
          fetchNursesHandoverData();
          setOpenPostModal(false);
          // setOpenIsbarNurseHandoverModal(false);

          // populateTable();
          // reset(defaultValues);
        } else {
          errorAlert(res.message);
        }
      })
      .catch((error) => {
        console.log(error);

        errorAlert(error?.response?.data?.message || error.message);
      })
      .finally(() => {
        setOpenBackdrop(false);
      });
  };

  const handlePasscodeClose = () => {
    setPasscodeModal(false);
    setPendingAcceptShift(null);
  };

  const handleAccept = async (shift, passcode) => {
    try {
      setOpenBackdrop(true);
      const shiftData = handoverResultArray?.find(
        (item) => item?.shift === shift,
      );

      const response = await acceptNursesHandoverSummary(
        shiftData?.id,
        shiftData?.handOverToId,
        // getUserInfo?.userId,
        passcode,
      );
      const res = response?.data;
      if (res?.statusCode === 200 || res?.statusCode === 201) {
        successAlert(res?.message);
        fetchNursesHandoverData();
        handlePasscodeClose();
      } else {
        errorAlert(res?.message);
      }
    } catch (error) {
      console.error(error);
      errorAlert(
        error?.response?.data?.message ||
          error?.message ||
          "Something went wrong",
      );
    } finally {
      setOpenBackdrop(false);
    }
  };
  useEffect(() => {
    fetchNursesHandoverData();
  }, [selectedRow]);

  return (
    <>
      {" "}
      <Modal open={openIsbarNurseHandoverModal}>
        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={ModalStyle} className="w-[98%] h-[95vh] overflow-y-auto">
              <div className="flex justify-between items-center">
                <h1 className="font-bold text-lg">
                  Nurses Handover Based On ISBAR
                </h1>

                <div className="flex gap-5 items-center">
                  <ViewIconISBAR
                    title={"Nurses Handover List"}
                    onClick={() => {
                      setNursesHandoverListingModal(true);
                    }}
                  />
                  <CloseModalIcon
                    onClick={() => {
                      setSelectedRow(null);
                      reset();
                      setOpenIsbarNurseHandoverModal(false);
                    }}
                  />
                </div>
              </div>

              <CommonDivider color="E0E0E0" />

              <div className="px-4 py-3 bg-gray-200 border border-gray-200 rounded-lg">
                <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-2 text-sm">
                  <div className="grid grid-cols-[135px_20px_1fr]">
                    <div className="font-semibold"> Patient Name</div>
                    <div className="text-center">:</div>
                    <div>{displayInfo?.["Patient Name"]}</div>
                  </div>

                  <div className="grid grid-cols-[100px_20px_1fr]">
                    <div className="font-semibold">MR No</div>
                    <div className="text-center">:</div>
                    <div>{displayInfo?.MRNo}</div>
                  </div>

                  <div className="grid grid-cols-[80px_20px_1fr]">
                    <div className="font-semibold">Age</div>
                    <div className="text-center">:</div>
                    <div>{displayInfo?.AgeYear}</div>
                  </div>

                  <div className="grid grid-cols-[130px_20px_1fr]">
                    <div className="font-semibold">Admitting Doctor</div>
                    <div className="text-center">:</div>
                    <div>{displayInfo?.DoctorName}</div>
                  </div>

                  <div className="grid grid-cols-[135px_20px_1fr]">
                    <div className="font-semibold">Bed No</div>
                    <div className="text-center">:</div>
                    <div>{displayInfo?.["Bed No"]}</div>
                  </div>
                </div>
              </div>

              <div className="mt-2 border-[2px] rounded-lg overflow-visible">
                <div className="grid grid-cols-4 bg-gray-200 px-3  py-2 font-semibold">
                  <div>ISBAR Criteria</div>
                  <div className="text-center">Morning</div>
                  <div className="text-center">Evening</div>
                  <div className="text-center">Night</div>
                </div>

                {handoverSections.map((sectionObj) => (
                  <div key={sectionObj?.section}>
                    <div className=" px-3 py-1.5   border-t-2 border-b">
                      <h3 className="font-bold text-sm tracking-wide">
                        {sectionObj?.section}
                      </h3>
                    </div>

                    {sectionObj?.fields.map((field, index) => (
                      <div
                        key={`${sectionObj?.section}-${index}`}
                        className="grid grid-cols-4  pl-3  items-center border-t border-gray-300"
                      >
                        <div className="font-medium text-sm border-r-2">
                          {field}
                        </div>

                        {["M", "E", "N"].map((shift) => (
                          <div
                            key={shift}
                            className={` border-gray-300 p-2 grid grid-cols-[40%_58%]  items-center ${shift === "M" ? "" : shift === "E" ? "bg-gray-200" : "bg-gray-300"}`}
                          >
                            <div className="flex gap-4 ">
                              <ISBARCheckbox
                                disabled={selectedRow !== null}
                                control={control}
                                name={`${field}_${shift}_Yes`}
                                label="Y"
                                onChange={(checked) => {
                                  if (checked) {
                                    setValue(`${field}_${shift}_No`, false);
                                  }
                                }}
                              />

                              <ISBARCheckbox
                                disabled={selectedRow !== null}
                                control={control}
                                name={`${field}_${shift}_No`}
                                label="N"
                                onChange={(checked) => {
                                  if (checked) {
                                    setValue(`${field}_${shift}_Yes`, false);
                                  }
                                }}
                              />
                            </div>

                            <InputField
                              disabled={selectedRow !== null}
                              control={control}
                              name={`${field}_${shift}_Remark`}
                              label="Remarks"
                            />
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div className="mt-2 border-gray-200 rounded-lg overflow-hidden ">
                {additionalHandoverFields.map((item) => (
                  <div key={item.id} className="grid grid-cols-4  pl-3">
                    <div className="flex justify-between">
                      <div className="font-medium text-sm flex items-center">
                        {item.text}
                      </div>
                      <div className="items-center flex">:</div>
                    </div>

                    <div className="p-3   border-gray-200">
                      <InputField
                        control={control}
                        name={`${item.text}_M_Remark`}
                        label={`${item.text}(M)`}
                        disabled={selectedRow !== null}
                      />
                    </div>

                    <div className="p-3 bg-gray-200  border-gray-200">
                      <InputField
                        control={control}
                        name={`${item.text}_E_Remark`}
                        label={`${item.text}(E)`}
                        disabled={selectedRow !== null}
                      />
                    </div>

                    <div className="p-3 bg-gray-300">
                      <InputField
                        control={control}
                        name={`${item.text}_N_Remark`}
                        label={`${item.text}(N)`}
                        disabled={selectedRow !== null}
                      />
                    </div>
                  </div>
                ))}
              </div>
              {/* <div className="flex justify-end mt-5">
              <CommonButton
                type="submit"
                label="Save"
                className="bg-customBlue text-white"
              />
            </div> */}
              <div className="mt-1 pl-3 text-sm   text-black overflow-visible w-full border-t border-gray-300">
                <div className="grid grid-cols-4">
                  {/* <div className=" py-2 font-semibold flex text-gray-600 border-r border-gray-200">
                  <div className="w-[150px]"> Handover By</div>
                </div> */}
                  <div className="flex justify-between">
                    <div className="font-semibold text-sm flex items-center">
                      Handover By
                    </div>
                    <div className="items-center flex">:</div>
                  </div>
                  <div className="px-4 py-2 text-start border-r border-gray-200 h-10">
                    {morningData?.handOverBy || "-"}
                  </div>

                  <div className="px-4 py-2 text-start border-r border-gray-200 bg-gray-200">
                    {eveningData?.handOverBy || "-"}
                  </div>

                  <div className="px-4 py-2 text-start bg-gray-300">
                    {nightData?.handOverBy || "-"}
                  </div>
                </div>

                <div className="grid grid-cols-4 ">
                  {/* <div className=" py-2 font-semibold flex text-gray-600 border-r border-gray-200 h-10">
                  <div className="w-[150px]">Handover To / Taken By</div>
                </div> */}
                  <div className="flex justify-between">
                    <div className="font-semibold text-sm flex items-center">
                      Handover To / Taken By
                    </div>
                    <div className="items-center flex">:</div>
                  </div>
                  <div className="px-4 py-2 w-full flex justify-between border-r  border-gray-200 ">
                    {morningData?.handOverBy ? (
                      <div className="flex items-center justify-between w-full">
                        <p className="py-1">
                          {
                            // morningData?.handOverTakenBy ||
                            morningData?.handOverToName || "-"
                          }
                        </p>

                        {/* {
                          !morningData?.accepted && !selectedRow && (
                            // morningData?.handOverToId === getUserInfo?.userId && (
                            <button
                              type="button"
                              onClick={() => {
                                setPendingAcceptShift("M");
                                setPasscodeModal(true);
                              }}
                              // onClick={() => handleAccept("M")}
                              className="px-4 py-1 rounded-md border border-customBlue text-customBlue hover:bg-customBlue hover:text-white transition-all duration-200"
                            >
                              Accept
                            </button>
                          )
                          // )
                        } */}
                        {morningData?.handOverBy &&
                          !morningData?.accepted &&
                          !selectedRow && (
                            <div className="flex gap-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setPendingAcceptShift("M");
                                  setPasscodeModal(true);
                                }}
                                className="px-4 py-1 rounded-md border border-customBlue text-customBlue hover:bg-customBlue hover:text-white transition-all duration-200"
                              >
                                Accept
                              </button>
                              {morningData?.handOverById ===
                                getUserInfo?.userId && (
                                <CommonButton
                                  onClick={() => setSelectedShift("M")}
                                  label="Update"
                                  type="submit"
                                  className="px-6 py-2 bg-green-700 hover:bg-green-800 text-white text-sm rounded-md transition-colors"
                                />
                              )}
                            </div>
                          )}
                      </div>
                    ) : !selectedRow ? (
                      <div className="w-full flex gap-1">
                        <SearchDropdown
                          handleInputChange={(e) => {
                            const tempCheckChar =
                              e !== null
                                ? UseCheckConsecutiveCharacters(e)
                                : true;
                            if (e !== "" && tempCheckChar) {
                              getNursingHandoverEmp({ searchString: e })
                                .then((response) => {
                                  setEmpData(response.data.result);
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            } else {
                              setEmpData([]);
                            }
                          }}
                          onChange={() => {}}
                          dataArray={empData}
                          control={control}
                          name="assignStaff"
                          placeholder="Handover To "
                          isClearable={true}
                          isSearchable={true}
                          menuPlacement="top"
                          searchIcon={true}
                        />

                        <CommonButton
                          onClick={() => setSelectedShift("M")}
                          label="Save"
                          type="submit"
                          className="px-6 py-2 bg-green-700 hover:bg-green-800 text-white text-sm rounded-md transition-colors"
                        />
                      </div>
                    ) : (
                      "-"
                    )}
                  </div>

                  <div className="px-4 py-2 flex justify-between border-r  border-gray-200 bg-gray-200">
                    {eveningData?.handOverBy ? (
                      <div className="flex items-center justify-between w-full">
                        <p className="py-1">
                          {
                            // eveningData?.handOverTakenBy ||
                            eveningData?.handOverToName || "-"
                          }
                        </p>

                        {/* {
                          !eveningData?.accepted && !selectedRow && (
                            // eveningData?.handOverToId === getUserInfo?.userId && (
                            <button
                              type="button"
                              onClick={() => {
                                setPendingAcceptShift("E");
                                setPasscodeModal(true);
                              }}
                              // onClick={() => handleAccept("E")}
                              className="px-4 py-1 rounded-md border border-customBlue text-customBlue hover:bg-customBlue hover:text-white transition-all duration-200"
                            >
                              Accept
                            </button>
                          )
                          // )
                        } */}
                        {eveningData?.handOverBy &&
                          !eveningData?.accepted &&
                          !selectedRow && (
                            <div className="flex gap-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setPendingAcceptShift("E");
                                  setPasscodeModal(true);
                                }}
                                className="px-4 py-1 rounded-md border border-customBlue text-customBlue hover:bg-customBlue hover:text-white transition-all duration-200"
                              >
                                Accept
                              </button>
                              {eveningData?.handOverById ===
                                getUserInfo?.userId && (
                                <CommonButton
                                  onClick={() => setSelectedShift("E")}
                                  label="Update"
                                  type="submit"
                                  className="px-6 py-2 bg-green-700 hover:bg-green-800 text-white text-sm rounded-md transition-colors"
                                />
                              )}
                            </div>
                          )}
                      </div>
                    ) : !selectedRow ? (
                      <div className="w-full flex gap-1">
                        <SearchDropdown
                          handleInputChange={(e) => {
                            const tempCheckChar =
                              e !== null
                                ? UseCheckConsecutiveCharacters(e)
                                : true;
                            if (e !== "" && tempCheckChar) {
                              getNursingHandoverEmp({ searchString: e })
                                .then((response) => {
                                  setEmpData(response.data.result);
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            } else {
                              setEmpData([]);
                            }
                          }}
                          onChange={() => {}}
                          dataArray={empData}
                          control={control}
                          name="assignStaffEvening"
                          placeholder="Handover To "
                          isClearable={true}
                          isSearchable={true}
                          menuPlacement="top"
                          searchIcon={true}
                        />

                        <CommonButton
                          onClick={() => setSelectedShift("E")}
                          label="Save"
                          type="submit"
                          className="px-6 py-2 bg-green-700 hover:bg-green-800 text-white text-sm rounded-md transition-colors"
                        />
                      </div>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div className="px-4 py-2 flex justify-between  bg-gray-300">
                    {nightData?.handOverBy ? (
                      <div className="flex  items-center justify-between w-full">
                        <p className="py-1 ">
                          {nightData?.handOverToName || "-"}
                        </p>

                        {/* {
                          !nightData?.accepted && !selectedRow && (
                            // nightData?.handOverToId === getUserInfo?.userId && (
                            <button
                              type="button"
                              onClick={() => {
                                setPendingAcceptShift("N");
                                setPasscodeModal(true);
                              }}
                              // onClick={() => handleAccept("N")}
                              className="px-4 py-1 rounded-md border border-customBlue text-customBlue hover:bg-customBlue hover:text-white transition-all duration-200"
                            >
                              Accept
                            </button>
                          )
                          // )
                        } */}

                        {nightData?.handOverBy &&
                          !nightData?.accepted &&
                          !selectedRow && (
                            <div className="flex gap-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setPendingAcceptShift("N");
                                  setPasscodeModal(true);
                                }}
                                className="px-4 py-1 rounded-md border border-customBlue text-customBlue hover:bg-customBlue hover:text-white transition-all duration-200"
                              >
                                Accept
                              </button>
                              {nightData?.handOverById ===
                                getUserInfo?.userId && (
                                <CommonButton
                                  onClick={() => setSelectedShift("N")}
                                  label="Update"
                                  type="submit"
                                  className="px-6 py-2 bg-green-700 hover:bg-green-800 text-white text-sm rounded-md transition-colors"
                                />
                              )}
                            </div>
                          )}
                      </div>
                    ) : !selectedRow ? (
                      <div className="w-full flex gap-1">
                        <SearchDropdown
                          handleInputChange={(e) => {
                            const tempCheckChar =
                              e !== null
                                ? UseCheckConsecutiveCharacters(e)
                                : true;
                            if (e !== "" && tempCheckChar) {
                              getNursingHandoverEmp({ searchString: e })
                                .then((response) => {
                                  setEmpData(response.data.result);
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            } else {
                              setEmpData([]);
                            }
                          }}
                          menuPlacement="top"
                          onChange={() => {}}
                          dataArray={empData}
                          control={control}
                          name="assignStaffNight"
                          placeholder="Handover To "
                          isClearable={true}
                          isSearchable={true}
                          searchIcon={true}
                        />

                        <CommonButton
                          onClick={() => setSelectedShift("N")}
                          label="Save"
                          type="submit"
                          className="px-6 py-2 bg-green-700 hover:bg-green-800 text-white text-sm rounded-md transition-colors"
                        />
                      </div>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </div>
            </Box>
            {openBackdrop && <CommonBackDrop openBackdrop={openBackdrop} />}
            {nursesHandoverListingModal && (
              <NursesHandoverListingModal
                nursesHandoverListingModal={nursesHandoverListingModal}
                setNursesHandoverListingModal={setNursesHandoverListingModal}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                admissionId={displayInfo?.AdmissionId}
                setOpenBackdrop={setOpenBackdrop}
                openBackDrop={openBackdrop}
              />
            )}
          </form>
          {passcodeModal && (
            <NursesHandoverPasscodeModal
              open={passcodeModal}
              onClose={handlePasscodeClose}
              onSubmit={(passcode) =>
                handleAccept(pendingAcceptShift, passcode)
              }
            />
          )}
        </div>
      </Modal>{" "}
      <ConfirmationModal
        confirmationOpen={openPostModal}
        confirmationHandleClose={() => setOpenPostModal(false)}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure you want to save this record?"
        confirmationSubmitFunc={() => {
          handleSaveRecord();
        }}
        confirmationButtonMsg="Save"
      />
    </>
  );
};

export default NursesHandoverBasedOnISBARModal;